import React from "react";
import { Breadcrumb } from "../../../components/Breadcrumb";
import { Button, SaveButton } from "../../../components/Buttons";

export const Return = () => {
    document.title = "Qaytarma";

    const menu = [
        { name: "Ana səhifə", value: "/" },
        { name: "Kassa", value: "/cash" },
        { name: "Qaytarma", value: "/cash/return", current: true },
    ];

    return (
        <div>
            <Breadcrumb menu={menu} />
            <div className="container">
                <article>
                    <h2 className="my-4">Satış</h2>
                    <p>
                        <ol>
                            <li>
                                Pərakəndə satışların qaytarmasını icra etmək üçün kassa proqramında <mark>Menyu</mark> seçimini edib açılan pəncərədə{" "}
                                <mark>satışlar</mark> yazısının üzərinə klik etmək lazımdır
                            </li>
                            <li>
                                Təqdim olunan satışların içindən hansı satışın qaytarmasının icra olunması təyin edilməlidir. Axtarış, məhsulun adına və
                                barkoduna görə, satış qaiməsinin nömrəsinə görə, məbləğə və Müştəri adına görə icra oluna bilər
                            </li>
                            <li>
                                Axtarışın nəticəsinə görə seçilmiş satış üzərinə klik etmək və açılan pəncərədə <Button>Geri qaytarma</Button> düyməsini sıxmaq
                                lazımdır
                            </li>
                            <li>
                                Qaytarılacaq məhsulun miqdarı təyin edilməli və <SaveButton /> düyməsi ilə qaytarma əməliyyatı tamamalanmalıdır
                            </li>
                        </ol>
                        <b>Qeyd</b>: Qaytarılacaq məbləğ nəğd, bonus, borc olaraq istifadəçiyə göstəriləcək
                    </p>
                    <img src="/images/cash/return.gif" alt="Satış" />
                </article>
            </div>
        </div>
    );
};
